import { useEffect } from 'react';
import analytics from '../services/analytics';

/**
 * Global form submission tracking hook using event delegation.
 *
 * Any <form> with a `data-track-form` attribute will be automatically tracked.
 *
 * Usage:
 *   <form data-track-form="login-form">...</form>
 *   <form data-track-form="otp-verification">...</form>
 */
export function useGlobalFormTracking() {
  useEffect(() => {
    const handler = e => {
      const form = e.target.closest('form[data-track-form]');
      if (form) {
        const formName = form.getAttribute('data-track-form');
        analytics.trackEvent('Form', 'submit', formName);
      }
    };

    document.addEventListener('submit', handler, true);
    return () => document.removeEventListener('submit', handler, true);
  }, []);
}

export default useGlobalFormTracking;
